var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      "fill-rule": "evenodd",
      d:
        "M68.926.865C59.048.642 19.48.912 9.366 11.301-4.758 25.806-4.504 54.258 21.855 60.784c24.214 5.995 55.452 8.621 67.08 8.883 7.593.172 46.905-2.032 61.683-12.577 10.38-7.406 10.26-20.568-.327-35.876C139.846 4.365 75.612 1.016 68.926.865z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad9364c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad9364c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/ShapeYearBtn3Tab.vue
// module id = E3ZS
// module chunks = 1